// src/Layout/MainLayout.js
import React from 'react';
import Header from '../Pages/Header/Header';
import MobileHeader from '../Pages/Header/MobileHeader';
import { Outlet } from 'react-router-dom';

const MainLayout = () => {
  return (
    <>
      {/* Desktop Header */}
      <div className="hidden md:block w-full">
        <Header />
      </div>

      {/* Mobile Header */}
      <div className="block md:hidden w-full">
        <MobileHeader />
      </div>

      {/* Main Content */}
      <main className="min-h-[80vh] p-4 bg-gray-50">
        <Outlet />
      </main>
    </>
  );
};

export default MainLayout;

// // src/Layout/MainLayout.js
// import React from 'react';
// import Header from '../Pages/Header/Header';
// import { Outlet } from 'react-router-dom';

// const MainLayout = () => {
//   return (
//     <>
//       <Header />
//       <main>
//         <Outlet />
//       </main>
//     </>
//   );
// };

// export default MainLayout;
